<template>
  <div class="w-full h-full py-5 flex flex-col gap-5">
    <h1 class="text-lg lg:text-2xl font-semibold dark_text">Attendance List</h1>
    <form @submit.prevent="filterList" class="flex flex-col lg:flex-row gap-5">
      <select
        name=""
        id=""
        class="bg_white rounded-md px-3 py-1.5 leading-tight focus:ring-0 focus:outline-none uppercase text-xs font-semibold"
      >
        <option value="">semester</option>
      </select>
      <select
        name=""
        id=""
        class="bg_white rounded-md px-3 py-1.5 leading-tight focus:ring-0 focus:outline-none uppercase text-xs font-semibold"
      >
        <option value="">course</option>
      </select>
      <select
        name=""
        id=""
        class="bg_white rounded-md px-3 py-1.5 leading-tight focus:ring-0 focus:outline-none uppercase text-xs font-semibold"
      >
        <option value="">subject code</option>
      </select>
      <select
        name=""
        id=""
        class="bg_white rounded-md px-3 py-1.5 leading-tight focus:ring-0 focus:outline-none uppercase text-xs font-semibold"
      >
        <option value="">section</option>
      </select>
      <select
        name=""
        id=""
        class="bg_white rounded-md px-3 py-1.5 leading-tight focus:ring-0 focus:outline-none uppercase text-xs font-semibold"
      >
        <option value="">session</option>
      </select>
      <div class="flex gap-5 items-center">
        <div class="flex justify-end items-center gap-3">
          <button
            type="submit"
            :disabled="disable_submit == true"
            :class="
              this.disable_submit == true
                ? 'bg-gray-200 text-black cursor-not-allowed'
                : 'attendance_btn hover:bg-[#18469d] cursor-pointer text-white'
            "
            class="rounded-md px-3 py-1.5 leading-tight text-xs font-semibold"
          >
            Submit
          </button>
          <img
            v-if="disable_submit"
            src="@/assets/loading.gif"
            alt="loading"
            class="w-6 h-6 object-contain"
          />
        </div>
        <button
          class="underline flex items-center clear_all leading-tight text-xs font-semibold"
        >
          <img
            src="@/assets/attendance/cancel.webp"
            alt=""
            class="w-3 h-3 object-contain"
          />
          clear all
        </button>
      </div>
    </form>
    <div class="w-full flex justify-end items-center">
      <router-link :to="{ name: 'AttendanceCalender' }">
        <button
          class="attendance_btn px-4 py-2 rounded-lg uppercase text-xs font-semibold"
        >
          view all
        </button>
      </router-link>
    </div>
    <div class="w-full overflow-scroll">
      <table class="min-w-full">
        <thead>
          <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
            <th class="px-6 py-3">S.No</th>
            <th class="px-6 py-3">Course</th>
            <th class="px-6 py-3">Subject/Subject Code</th>
            <th class="px-6 py-3">Program</th>
            <th class="px-6 py-3">Student Count</th>
            <th class="px-6 py-3">Practical</th>
            <th class="px-6 py-3">Elective</th>
            <th class="px-6 py-3">Semester</th>
            <th class="px-6 py-3">Section</th>
            <th class="px-6 py-3">Session</th>
            <th class="px-6 py-3">Day</th>
          </tr>
        </thead>
        <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
          <tr class="w-full">
            <td colspan="12" class="text-center py-6">
              <div class="flex items-center justify-center">
                <img src="@/assets/attendance/loading.gif" alt="" />
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <template v-if="attendance_list.length > 0">
            <tr
              v-for="(list, index) in attendance_list"
              :key="index"
              class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3">{{ index + 1 }}</td>
              <td class="px-6 py-3">{{ list.course }}</td>
              <td class="px-6 py-3">
                {{ list.subject }} - {{ list.subject_code }}
              </td>
              <td class="px-6 py-3">{{ list.program }}</td>
              <td class="px-6 py-3">{{ list.student_count }}</td>
              <td class="px-6 py-3">
                <span v-if="list.practical != null">{{ list.practical }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">
                <span v-if="list.elective != null">{{ list.elective }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">{{ list.semester }}</td>
              <td class="px-6 py-3">{{ list.section }}</td>
              <td class="px-6 py-3">{{ list.session }}</td>
              <td class="px-6 py-3">{{ list.day }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="11" class="px-6 py-3 text-center">No Data Found</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="11" class="p-6 bg-[#18469d]"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      attendance_list: [],
      loading: true,
      disable_submit: false,
    };
  },
  async created() {
    await this.getAttendanceStats();
  },
  methods: {
    getAttendanceStats() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/staff-attendance-list/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          console.log("resp", resp);
          if (resp.data.status == 200) {
            this.attendance_list = resp.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
  },
};
</script>

<style></style>
